import { render, staticRenderFns } from "./logbook-reminder-checkbox.vue?vue&type=template&id=7c52645c&scoped=true"
import script from "./logbook-reminder-checkbox.vue?vue&type=script&lang=js"
export * from "./logbook-reminder-checkbox.vue?vue&type=script&lang=js"
import style0 from "./logbook-reminder-checkbox.vue?vue&type=style&index=0&id=7c52645c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c52645c",
  null
  
)

export default component.exports